import { addOrganization as addOrganizationApi } from "../api/organizationApi";

type Progress = { current: number; total: number; stage: string };

// experience-backend's POST /organization creates an organization + first
// team + first team member in one call (OrganizationSetupService), but
// there's no delete endpoint yet.
export const OrganizationService = {
  async addOrganization(organizationName: string, _userId: string): Promise<string> {
    const result = await addOrganizationApi({
      organizationName,
      teamName: `${organizationName} Team`,
    });
    return result.organizationId;
  },

  async deleteOrganization(
    _organizationId: string,
    onProgress?: (progress: Progress) => void
  ): Promise<void> {
    console.warn(
      "OrganizationService.deleteOrganization: not supported by experience-backend yet."
    );
    onProgress?.({ current: 0, total: 0, stage: "unsupported" });
  },
};
